import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollamaContainer from "./components/ScrollamaContainer";
import OutcomesSection from "./components/OutcomesSection";
import MobileContent from "./components/MobileContent";
import { useMediaQuery } from "react-responsive";

function App() {
  const [showTest, setShowTest] = useState(true);
  const isMobile = useMediaQuery({ maxWidth: 999 });

  return (
    <div className="app">
      <Header />
      {/* <div style={{ padding: "10px", textAlign: "center" }}>
        <button
          onClick={() => setShowTest(!showTest)}
          style={{
            padding: "8px 16px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginBottom: "10px",
          }}
        >
          {showTest ? "Show Timeline" : "Test Supabase Connection"}
        </button>
      </div> */}
      <main>
        {isMobile ? <MobileContent /> : <ScrollamaContainer />}
        <div style={{ padding: "4rem 0", backgroundColor: "#f3f4f6" }}>
          <OutcomesSection />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
